export  const checkPermissions=(loginData,requestedAction)=>{
    const groupPermissions = (loginData && loginData.group_permissions) ? loginData.group_permissions : [];
    const userPermissions = (loginData && loginData.user_permissions) ? loginData.user_permissions : [];
    const isAdmin = (loginData && loginData.is_sup_admin === 1) ? true : false;
    return (groupPermissions.includes(`${requestedAction}`) || userPermissions.includes(`${requestedAction}`) || isAdmin)?true:false;
}